import { render, staticRenderFns } from "./StartProjectModal.vue?vue&type=template&id=02f71fe6&scoped=true"
import script from "./StartProjectModal.vue?vue&type=script&lang=js"
export * from "./StartProjectModal.vue?vue&type=script&lang=js"
import style0 from "./StartProjectModal.vue?vue&type=style&index=0&id=02f71fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f71fe6",
  null
  
)

export default component.exports